module.exports = __webpack_public_path__ + "img/027-exploration.82eb3edf.svg";